import React from 'react';
import { Link } from 'react-router-dom';

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-xl font-semibold text-gray-900 mb-3">{title}</h2>
    <div className="space-y-3 text-gray-600 text-sm leading-relaxed">{children}</div>
  </section>
);

const Terms = () => {
  return (
    <div className="bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900">Terms &amp; Conditions</h1>
        <p className="mt-2 text-sm text-gray-500">Last updated: June 2026</p>

        <p className="mt-6 text-sm text-gray-600 leading-relaxed">
          Welcome to BeyondXL. These Terms &amp; Conditions ("Terms") govern your use of our
          website and the purchase of products from us. By accessing our website, creating an
          account, or placing an order, you agree to be bound by these Terms. Please read them
          carefully.
        </p>

        <div className="mt-8">
          <Section title="1. About Us">
            <p>
              BeyondXL is a premium plus-size fashion brand offering shirts and apparel in sizes
              2XL to 7XL and beyond. References to "we", "us" or "our" mean BeyondXL.
            </p>
          </Section>

          <Section title="2. Eligibility &amp; Accounts">
            <p>
              You must be at least 18 years of age, or accessing the site under the supervision of a
              parent or legal guardian, to use our services. When you create an account, you agree to
              provide accurate information (a valid email address or phone number) and to keep your
              login credentials secure. You are responsible for all activity that occurs under your
              account.
            </p>
          </Section>

          <Section title="3. Products, Pricing &amp; Availability">
            <p>
              All prices are listed in Indian Rupees (INR) and are inclusive of applicable taxes
              unless stated otherwise. We make every effort to display product colours, sizing and
              details accurately, but actual appearance may vary slightly due to screen settings.
            </p>
            <p>
              Products are subject to availability. We reserve the right to modify or discontinue any
              product, and to correct pricing errors, at any time without prior notice.
            </p>
          </Section>

          <Section title="4. Orders &amp; Acceptance">
            <p>
              Placing an order constitutes an offer to purchase. All orders are subject to acceptance
              and stock availability. We reserve the right to refuse or cancel any order, including in
              cases of suspected fraud, pricing errors, or unavailability of stock. If we cancel an
              order after payment, you will be refunded in full.
            </p>
          </Section>

          <Section title="5. Coupons &amp; Promotional Offers">
            <p>
              Discount codes (such as <span className="font-medium">WELCOMEBXL</span> and
              <span className="font-medium"> BXL30</span>) are subject to their individual terms,
              including minimum order values, usage limits and expiry dates. Offers cannot be combined
              unless expressly stated, and we reserve the right to withdraw any promotion at any time.
            </p>
          </Section>

          <Section title="6. Payments">
            <p>
              Payments are processed securely through our payment partner, Razorpay. We do not store
              your card or banking details on our servers. By making a payment, you agree to the terms
              of the relevant payment provider. Orders are confirmed only after successful payment
              authorisation.
            </p>
          </Section>

          <Section title="7. Shipping &amp; Delivery">
            <p>
              We aim to dispatch and deliver orders within the estimated timelines shown at checkout.
              Delivery times are estimates and may vary due to factors beyond our control. Risk in the
              products passes to you upon delivery.
            </p>
          </Section>

          <Section title="8. Returns, Exchanges &amp; Refunds">
            <p>
              Returns and exchanges are handled in line with our{' '}
              <Link to="/returns" className="text-black underline hover:text-gray-700">
                Returns, Exchanges &amp; Refunds policy
              </Link>
              . Please review it for eligibility, timelines and the process to follow.
            </p>
          </Section>

          <Section title="9. Intellectual Property">
            <p>
              All content on this website, including logos, images, text and design, is the property
              of BeyondXL and is protected by applicable intellectual property laws. You may not
              reproduce or use any content without our prior written permission.
            </p>
          </Section>

          <Section title="10. Acceptable Use">
            <p>
              You agree not to misuse the website, attempt to gain unauthorised access, interfere with
              its operation, or use it for any unlawful purpose.
            </p>
          </Section>

          <Section title="11. Limitation of Liability">
            <p>
              To the maximum extent permitted by law, BeyondXL shall not be liable for any indirect or
              consequential loss arising from the use of our website or products. Our total liability
              for any order shall not exceed the amount paid for that order.
            </p>
          </Section>

          <Section title="12. Governing Law">
            <p>
              These Terms are governed by the laws of India. Any disputes shall be subject to the
              exclusive jurisdiction of the courts of India.
            </p>
          </Section>

          <Section title="13. Contact Us">
            <p>
              For any questions about these Terms, please contact us at{' '}
              <a href="mailto:support@beyondxl.in" className="text-black underline hover:text-gray-700">
                support@beyondxl.in
              </a>
              .
            </p>
          </Section>
        </div>
      </div>
    </div>
  );
};

export default Terms;
